export const SECTION_LOGIN = 'login';
export const SECTION_SIGNUP = 'signup';
export const SECTION_RESET = 'reset';
export const SECTION_SWITCH = 'switch';
export const SECTION_ADDITIONAL_INFO = 'additionalInfo';
export const SECTION_CHANGE_PASSWORD = 'change';
export const SECTION_AGE_GATE_FAIL = 'ageGateFail';
export const SECTION_AGE_GATE_FAIL_CREATE_ACCOUNT = 'ageGateFailCreateAccount';
export const DEFAULT_REGISTER_TITLE = 'Create Account';
export const DEFAULT_REGISTER_DESCRIPTION = '';
export const DEFAULT_ANALYTICS_NAME = 'React';
export const DEFAULT_REGISTER_BUTTON_TEXT = 'Create Account';
export const DEFAULT_SIGNIN_DESCRIPTION = '';
export const DEFAULT_SIGNIN_TITLE = 'Log In';
export const REGMODAL_READY_EVENT = 'regModalReady';
export const DISPATCH_EVENT = 'openRegModal';
export const CLOSE_REG_MODAL = 'closeRegModal';
export const ACCOUNT_INFO = 'accountInfo';
export const isCookieSet = name => {
  const regex = new RegExp(`(^|;)\\s*${name}=[^;]+`);
  return !!document.cookie.match(regex);
};
export const RESPONSE_CODE_TOO_MANY_REQUESTS = 429;
export const RESPONSE_CODE_VERIFICATION_FAILED = 432;
export const RECAPTCHA_SITE_KEY = '6LeyMfAUAAAAAHdUUd8sUtvTgW2SsVvKRpibXwqn';
export const EMPTY_RECAPTCHA = 'Please check the "I am not a robot" box above.';
